import { QRCode } from 'antd';
import { useMemo } from 'react';
import { InvoiceInterface } from '../../../interfaces/invoice.interface';
import { getAadeQrUrl } from '../../../services/utils/myDataUtils';

interface Props {
  doc: InvoiceInterface;
}

// Split out of `DocViewAadeData.tsx` so it can be placed next to `DocViewNotes` in normal content
// flow instead of the page-edge-pinned `.footer` div — that absolute positioning was clipping the
// QR on print, making it unscannable.
export const DocViewQrCode = ({ doc }: Props) => {
  const qrCodeLink = useMemo(() => getAadeQrUrl(doc), [doc]);

  if (!doc?.sentToAade) return null;

  return (
    <div className="p-l-8 p-t-4">
      <a
        href={qrCodeLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: 'inline-block' }}
        tabIndex={0}
        aria-label="AADE QR Link">
        <QRCode value={qrCodeLink} size={70} bordered={false} />
      </a>
    </div>
  );
};
